<template>
    <div class="pmtdiv">
        <!-- <smallbutton :toplabel="name" @click="startAdd()" v-if="showButton" :buttonclass="buttonClass"/>
        <linkbutton :toplabel="name" @click="startAdd()" v-if="!showButton"/> -->
        <!--  MODAL -->
          <actionmodal ref="mymodal"> 
            <template v-slot:body>
                <form ref="balform">
                    <label class="titlelabel">{{name}}</label>
                    <br/>

                    <div class="entry">    
                        <div class="entryTextDiv">
                            <label class="entryLabel" for="cardnum">Gift Card Number</label>
                            <label class="required">*</label>
                        </div>
                        <input id="cardnum" class="entryText capital"  name="" ref="cardnum" required="true" v-model="numberData"
                            @focus="$event.target.select()" >
                        
                    </div>

                    <!-- <formentry ref="cardnum"  label="Gift Card Number"  v-model="numberData" isrequired="True" /> -->
                    <formentry  isrequired="True" label="Amount $"  v-model="amount"  />
                    
    
                    <smallbutton  @click="Save()" toplabel="Save" buttonclass="button buttonsave"/>
                    <smallbutton  @click="$refs.mymodal.closeModal()" toplabel="Close" buttonclass="button buttoncancel"/>
                    <div>
                        <label class="responsemessage">{{responseMessage}}</label>
                    </div>
                    
                </form>
                
                
            </template>
          </actionmodal>
        </div>
    </template>
    
    <script>
    import {mapFields} from 'vuex-map-fields'
    import format from '../../style/format.js'
    import smallbutton from '../controls/button.vue'
    import linkbutton from '../controls/linkbutton.vue'
    import actionmodal from '../controls/actionmodal.vue'
    import formentry from '../controls/entry.vue'
    export default {
        name:'giftcard',
        components:{
            smallbutton,
            actionmodal,
            formentry,
            linkbutton
        },
        props:{
           
            showButton:{
                type:Boolean,
                default:true
            },
            name:{
                type:String,
                default:'Gift Card Details'
            },
            defaultAmount:{
                type:Number,
            },
            numberDataLabel:{
                type:String,
                default:''
            },
            buttonClass:{
                type:String,
                default:'button buttonpay'
            }
            
        },
        mixins:[format],
        data(){
            return{
                
                amount:0,
                numberData:null
                
            }
        },
        computed:{
            ...mapFields([
                'responseMessage',
                'pleaseWait'
            ]),
            
        },
        methods:{
            
            startAdd(){
                this.responseMessage=null
                this.numberData=null
                this.amount=0
                this.$refs.mymodal.openModal()
                this.$nextTick(()=>{
                    this.$refs.cardnum.focus()
                });
            },
            Save(){
                if(this.amount==0){
                    this.responseMessage="Please enter an amount greater than $0"
                    return
                }
                this.$emit('save',this.amount,this.numberData)
                this.$refs.mymodal.closeModal()
            }
        }
    }
    </script>
    
    <style>
    
    </style>
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    